import chroma from "chroma-js";

export type ThemeInput = {
  mode: "light" | "dark";
  background: string; // hex color
  card: string; // hex color
  // Optional status color overrides
  destructive?: string;
  success?: string;
  warning?: string;
  info?: string;
};

// Derived theme only contains background/card/status colors
// Primary/accent/ring are NOT derived - they stay at Tailwind defaults
// Brand color for charts is passed separately via props
export type DerivedTheme = {
  background: string;
  foreground: string;
  card: string;
  cardForeground: string;
  popover: string;
  popoverForeground: string;
  secondary: string;
  secondaryForeground: string;
  muted: string;
  mutedForeground: string;
  destructive: string;
  destructiveForeground: string;
  border: string;
  input: string;
  success: string;
  successForeground: string;
  warning: string;
  warningForeground: string;
  info: string;
  infoForeground: string;
};

/**
 * Convert a hex color to HSL string format for CSS variables
 * Returns "h s% l%" format (without commas, for CSS custom properties)
 */
export function hexToHSL(hex: string): string {
  const [h, s, l] = chroma(hex).hsl();
  // Handle achromatic colors (grays) where hue is NaN
  const hue = Number.isNaN(h) ? 0 : Math.round(h);
  return `${hue} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}
